<template>
  <v-row justify="center">
    <v-dialog v-model="isVisible" @click:outside="close()" max-width="290">
      <v-card class="text-center">
        <v-card-title
          class="headline justify-center text-h6 font-weight-medium"
          :class="textColor + '--text'"
          >{{ title }}</v-card-title
        >
        <v-card-text v-if="text != null">{{ text }}</v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    isVisible: Boolean,
    title: String,
    text: String,
    textColor: String
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    }
  }
};
</script>
